// extracted by mini-css-extract-plugin
module.exports = {"main":"Project-module--main--10-7F","hero":"Project-module--hero--2kLQm","info":"Project-module--info--4X_jI","gallery":"Project-module--gallery--AX8ib"};